<ng-container *ngIf="dataLoading">
  <div class="dataLoading py-5">
    <mat-spinner class="m-auto" diameter="50"></mat-spinner>
  </div>
</ng-container>

<ng-container *ngIf="!dataLoading">

  <div class="d-flex" style="height: 100vh">
    <div class="data-empty p-0 m-auto text-center">
      <!-- <img src="./assets/images/icons/notEnoughFund.svg" /> -->
      <div class="w-100 mt-3 text-center">
        <h1>{{"companyAdminProfile.Payment Operation Failed,please try again."|translate}}</h1>
        <!-- <p>Payment Operation Failed</p> -->
        <button mat-button class="btnLight_fill my-4" (click)="goToCpmapanyProfile();">{{'companyAdminProfile.Go Back' |
          translate}}</button>

      </div>
    </div>
  </div>
</ng-container>